module.exports = __webpack_public_path__ + "img/20180815_150347_074.764a0b14.jpg";